import type { ChangelogEntry } from "../types";

/** Kundekort v2 lagt om til wireframen: hero med knapper og pipe-kort, to kolonner. */
export const KUNDEKORT_WIREFRAME_2026_10: ChangelogEntry = {
  id: "2026-10-19-kundekort-wireframe",
  date: "2026-10-19",
  title: "Kundekortet har fått skissens oppsett: alt du gjør til venstre, alt du trenger å vite til høyre",
  summary:
    "Toppen av kundekortet viser nå status, eier, kontakt og knappene du handler med, og et blått kort med verdien i pipen. Under ligger neste steg, tilbud ute, løpende avtaler og det vi har laget i hovedkolonnen, og signaler, overvåkning, kontaktpersoner, siste kontakt, møter og bedriften i sidekolonnen.",
  sections: [
    {
      heading: "Toppen av kundekortet",
      items: [
        {
          title: "Knapperad for det du gjør oftest",
          kind: "nytt",
          featureFlag: "feature_crm_kundekort",
          body: "«Nytt tilbud», «Logg kontakt» (e-post, samtale eller notat), «Ny handling», «Book møte» og «Rediger» ligger rett under kundenavnet. «Rediger» samler e-post, telefon, faktura-e-post og adresse, og lagrer i PowerOffice først.",
        },
        {
          title: "Verdi i pipe nå",
          kind: "nytt",
          featureFlag: "feature_crm_kundekort",
          body: "Det blå kortet viser vektet verdi av tilbudene i kundens åpne prosesser, antall tilbud og neste forventede close, med solgt totalt, BF reell i prosent og reell timepris under. Nøkkeltall-raden som lå under toppen er borte; tallene bor i kortet og i prosjekttabellen.",
        },
        {
          title: "Eier, kontakt, org.nr og kunde siden på én linje",
          kind: "forbedret",
          featureFlag: "feature_crm_kundekort",
          body: "Metalinjen under statusen viser eier med «Endre», hovedkontakt med «Send e-post», organisasjonsnummer og året kunden kom til.",
        },
      ],
    },
    {
      heading: "Hovedkolonnen",
      items: [
        {
          title: "Neste steg teller og lenker til ukeslisten",
          kind: "forbedret",
          featureFlag: "feature_crm_ko_pipe",
          body: "Overskriften sier «3 forslag · 1 haster», gruppene ASAP og Denne uken har farge, og forklaringen på hver oppfølging står under tittelen. «Ny oppfølging» er blitt «Ny handling» i toppen.",
        },
        {
          title: "Tilbud ute som kort",
          kind: "forbedret",
          featureFlag: "feature_crm_kundekort",
          body: "Hvert sendt tilbud har eget kort med beløp, sjanse og forventet close med dager igjen. Utløpte tilbud er merket. Prosesser som ennå ikke har tilbud ligger under som «Prosesser uten tilbud».",
        },
        {
          title: "Løpende avtaler med kr/år, autosend og «Forny»",
          kind: "forbedret",
          body: "Avtaleseksjonen heter «Løpende avtaler», viser antall aktive og årlig beløp, har en Autosend-kolonne og merker avtaler som utløper innen 60 dager med «Utløper snart» og et «Forny»-valg.",
        },
        {
          title: "Det vi har laget, med tall per prosjekt",
          kind: "forbedret",
          body: "Prosjekthistorikken viser levert-dato, kontrakt, BF reell i prosent, reell timepris og feilbudsjettering per prosjekt. Utestående fakturaer står i bunnlinjen, og fakturalisten ligger bak «Fakturaer og logg».",
        },
      ],
    },
    {
      heading: "Sidekolonnen",
      items: [
        {
          title: "Siste kontakt i stedet for hele loggen",
          kind: "forbedret",
          featureFlag: "feature_crm_kundekort",
          body: "Sidekolonnen viser de fem siste radene i kontaktloggen med hvor lenge siden de var. «Logg» åpner hele tidslinjen i en dialog.",
        },
        {
          title: "Hva skjer hos dem, Overvåkning og Bedriften",
          kind: "forbedret",
          featureFlag: "feature_crm_signaler",
          body: "Signalene har kildemerke og lenke «har forslag» til køen. Overvåkning viser Aktiv-status, OK/Feil/Av per kilde og kostnad hittil. Bedriften viser omsetning med vekst, resultat, ansatte, bransje og daglig leder i kortform.",
        },
      ],
    },
  ],
};
